import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import axios from "axios";
import { Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LoginPage() {
  const { user, setUser, child, setChild } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && child) {
      navigate("/app", { replace: true });
      return;
    }
    if (user && !child) {
      navigate("/onboarding", { replace: true });
      return;
    }
    const autoLogin = async () => {
      try {
        const res = await axios.post(`${API}/auth/verify-otp`, { phone: "demo-user", otp: "0000" });
        setUser(res.data.user);
        if (res.data.onboarded && res.data.children?.length > 0) {
          setChild(res.data.children[0]);
          navigate("/app", { replace: true });
        } else {
          navigate("/onboarding", { replace: true });
        }
      } catch {
        setUser({ id: "demo", phone: "demo-user" });
        navigate("/onboarding", { replace: true });
      }
    };
    autoLogin();
  }, [user, child, navigate, setUser, setChild]);

  return (
    <div className="min-h-screen bg-[#FAFAF7] flex flex-col items-center justify-center p-6">
      <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#8E9B82]/20 to-[#D4A373]/20 flex items-center justify-center mb-5 animate-pulse">
        <Sparkles size={24} className="text-[#D4A373]" />
      </div>
      <h1 className="font-outfit text-5xl font-medium text-[#2F3630] tracking-tight mb-3">aavaa</h1>
      <p className="font-manrope text-[#6B7264] text-base mb-1">
        Your child's day, understood
      </p>
      <p className="font-manrope text-[#8E9B82] text-sm">
        so you never have to worry
      </p>
    </div>
  );
}
